"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* Disabling camelcasing for this file for API request parameters */
/* eslint-disable @typescript-eslint/camelcase */
var safe_access_1 = __importDefault(require("safe-access"));
var assign_1 = __importDefault(require("lodash/assign"));
var js_logger_1 = __importDefault(require("js-logger"));
var nucleus_1 = require("@lifesize/nucleus");
var remoting_1 = __importDefault(require("../actions/remoting"));
var wireless_presentation_1 = __importDefault(require("../actions/wireless-presentation"));
var lifesize_connect_1 = __importDefault(require("../actions/lifesize-connect"));
var pairing_1 = require("../constants/pairing");
var HTTP_GET = nucleus_1.nucleusConstants.HTTP_GET, HTTP_POST = nucleus_1.nucleusConstants.HTTP_POST, PROD_CLUSTER_URL = nucleus_1.nucleusConstants.PROD_CLUSTER_URL, CLIENT_ID_DASH_DISPLAY = nucleus_1.nucleusConstants.CLIENT_ID_DASH_DISPLAY, CLIENT_ID_DASH_REMOTE = nucleus_1.nucleusConstants.CLIENT_ID_DASH_REMOTE;
/**
 * Creates a new display device (checks for valid/unused name, availability of license, etc.)
 * @param {string} deviceName A string used to name the new device/room
 */
function createDevice(deviceName) {
    return function (dispatch, getState) {
        var state = getState();
        var groupUUID = safe_access_1.default(state, 'nucleus.userProfile.groupUuid');
        // reset any existing error state
        dispatch({ type: pairing_1.actions.CREATE_DISPLAY_DEVICE_REQUEST });
        return dispatch(nucleus_1.proxyActions.proxyApiCall(pairing_1.deviceInfoService.name, pairing_1.deviceInfoService.actions.create, HTTP_POST, {
            groupUUID: groupUUID,
            name: deviceName
        }))
            .then(function (response) { return dispatch(createDeviceResponse(response)); })
            .catch(function (reason) { return dispatch(createDeviceFailed(reason)); });
    };
}
/**
 * Returns a createDevice response action (even though the api call was successful, 'WAMP_SEND_SUCCESS' may actually
 * return an error in the response)
 * @param response An HTTP response object
 */
function createDeviceResponse(response) {
    var _a = JSON.parse(response), body = _a.body, statusCode = _a.statusCode;
    var responseBody = body && JSON.parse(body);
    if (statusCode && statusCode >= 400) {
        throw responseBody;
    }
    var _b = safe_access_1.default(responseBody, 'deviceInfo') || {}, displayPlatform = _b.controllerType, uuid = _b.deviceUUID, displayCipher = _b.roomPairingCipher;
    return {
        type: pairing_1.actions.CREATE_DISPLAY_DEVICE_SUCCESS,
        payload: {
            displayCipher: displayCipher,
            displayPlatform: displayPlatform,
            uuid: uuid
        }
    };
}
/**
 * Returns a createDevice failure error
 * @param {Error} error An error describing why the request failed
 */
function createDeviceFailed(error) {
    return {
        type: pairing_1.actions.CREATE_DISPLAY_DEVICE_FAILURE,
        payload: { error: error }
    };
}
/**
 * Generates a linking (QR) code that can be used to link a display with a remote (you should also subscribeToLinking to get updates)
 * @param linkType = {graphite-tablet'|'graphite-presenter'|'gems-tablet'|'gems-presenter'} The type of remote/controller (default)
 * @param platform = The platform to generate the link code for (this is used from admin console)
 * @param serialNumber = The serialNumber of the device (this is used from admin console)
 */
function generateLinkingCode(linkType, platform, serialNumber) {
    if (linkType === void 0) { linkType = pairing_1.linkedDeviceTypes.tablet; }
    if (platform === void 0) { platform = undefined; }
    if (serialNumber === void 0) { serialNumber = undefined; }
    return function (dispatch, getState) {
        var state = getState();
        var _a = safe_access_1.default(state, 'app.remoting.pairing') || {}, displayPlatform = _a.displayPlatform, uuid = _a.uuid;
        // proxyApiCall(service, uriSuffix, httpMethod, inputParams = null, queryParams = null)
        // TODO: add error handling here
        // sample success: {"statusCode":200,"headers":{"Content-Type":"application/json"},"body":"\"PQM8JX\""}
        // sample error: {"statusCode":400,"headers":{"Content-Type":"application/json"},"body":"\"no uriSuffix in the request\""}
        // note: for this call, we need to include the uriSuffix in the inputParams
        // note: it is permissible to add extra date in the linkDescription (for future use)
        // reset any existing error state
        dispatch({ type: pairing_1.actions.GENERATE_LINKING_CODE_REQUEST });
        return dispatch(nucleus_1.proxyActions.proxyApiCall(pairing_1.devicePairingService.name, pairing_1.devicePairingService.actions.generate, HTTP_POST, {
            deviceUUID: serialNumber ? serialNumber : uuid,
            linkDescription: {
                type: linkType
            },
            platform: platform ? platform : displayPlatform
        }))
            .then(function (response) { return dispatch(generateLinkingCodeResponse(response)); })
            .catch(function (reason) { return dispatch(generateLinkingCodeFailed(reason)); });
    };
}
/**
 * Returns a generateLinkingCode response action
 * @param response An HTTP response object
 */
function generateLinkingCodeResponse(response) {
    if (typeof response !== 'object')
        throw new Error('Argument "response" expected to be an object');
    var body = response.body, statusCode = response.statusCode;
    if (statusCode && statusCode >= 400) {
        throw body;
    }
    // this return will be duplicated by the WAMP_SUBSCRIPTION_LINKING_EVENT
    return {
        type: pairing_1.actions.GENERATE_LINKING_CODE_SUCCESS,
        payload: {
            remoteLinkingCode: safe_access_1.default(body, 'pairingCode')
        }
    };
}
/**
 * Returns a generateLinkingCode failure error
 * @param error An error describing why the request failed
 */
function generateLinkingCodeFailed(error) {
    return {
        type: pairing_1.actions.GENERATE_LINKING_CODE_FAILURE,
        payload: { error: error }
    };
}
/**
 * Unlink the display from the remote (tablet)
 * Note: pass only the tablet's uuid, the api will use the jwt to determine the display's identity
 */
function unlinkDisplay() {
    return function (dispatch, getState) {
        var state = getState();
        var pairedUuid = safe_access_1.default(state, 'app.remoting.pairing.pairedUuid') || '';
        var actualPairedUuid = pairedUuid.split('.').shift(); // TEMP HACK FOR WEIRD APPENDAGE (ASK PAUL)
        if (actualPairedUuid) {
            // stop wireless presentation if active
            if (safe_access_1.default(state, 'app.remoting.wirelessPresentation.receiving'))
                dispatch(wireless_presentation_1.default.stopWirelessPresentation());
            return dispatch(nucleus_1.proxyActions.proxyApiCall(pairing_1.devicePairingService.name, pairing_1.devicePairingService.actions.unlink, HTTP_POST, {
                uuid: actualPairedUuid
            }))
                .then(function (response) { return handleUnlinkDisplayResponse(response, actualPairedUuid, dispatch); })
                .catch(function (reason) { return handleUnlinkDisplayFailure(reason, dispatch); });
        }
    };
}
function unlinkConnect(connectUUID) {
    return function (dispatch, getState) {
        var state = getState();
        // stop wireless presentation if active
        if (safe_access_1.default(state, 'app.remoting.lifesizeConnect.sending'))
            dispatch(lifesize_connect_1.default.stopLifesizeConnectPresentation());
        return dispatch(nucleus_1.proxyActions.proxyApiCall(pairing_1.devicePairingService.name, pairing_1.devicePairingService.actions.unlink, HTTP_POST, {
            uuid: connectUUID
        }))
            .then(function (response) { return handleUnlinkDisplayResponse(response, connectUUID, dispatch); })
            .catch(function (reason) { return handleUnlinkDisplayFailure(reason, dispatch); });
    };
}
function unlinkDisplayAsAdmin(deviceUUID, tabletUUID) {
    return function (dispatch) {
        // Sets isUnlinking on state to true
        dispatch({ type: pairing_1.actions.REMOTE_UNLINK_BEGIN });
        return dispatch(nucleus_1.proxyActions.proxyApiCall(pairing_1.devicePairingService.name, pairing_1.devicePairingService.actions.unlink, HTTP_POST, {
            deviceUUID: deviceUUID,
            uuid: tabletUUID
        }))
            .then(function (response) { return handleUnlinkDisplayResponse(response, tabletUUID, dispatch); })
            .catch(function (reason) { return handleUnlinkDisplayFailure(reason, dispatch); });
    };
}
function resetPairingState() {
    return function (dispatch) {
        dispatch({ type: pairing_1.actions.RESET_PAIRING_STATE });
    };
}
/**
 * Update LS Connect enabled status in Admin Console.
 */
function updateDeviceSetting(serialNumber, connectType, displayNumber) {
    return function (dispatch) {
        return dispatch(nucleus_1.proxyActions.proxyApiCall(pairing_1.devicePairingService.name, pairing_1.devicePairingService.actions.deviceSettings, HTTP_POST, {
            serialNumber: serialNumber,
            lsConnect: {
                connectType: connectType,
                displayNumber: displayNumber,
            }
        }))
            .then(function () {
            js_logger_1.default.info('Successfully posted LS connect enabled status change to Admin Console.');
        })
            .catch(function (err) {
            js_logger_1.default.error('Error posting LS connect enabled status change to Admin Console: ', err);
        });
    };
}
/**
 * Returns a unlinkDisplay response action
 * @param response An HTTP response object
 * @param pairedUuid
 */
function unlinkDisplayResponseAction(response, pairedUuid) {
    var body = response.body, statusCode = response.statusCode;
    var responseBody = (body && JSON.parse(body)) || {};
    if (statusCode && statusCode >= 400) {
        throw responseBody;
    }
    if (responseBody.unlinkedUUID === pairedUuid) {
        return { type: pairing_1.actions.REMOTE_UNLINK_SUCCESS };
    }
    // All paths should return a value
    return {
        type: pairing_1.actions.REMOTE_UNLINK_FAILED,
        payload: 'The unlinked display UUID does not match the requested UUID'
    };
}
/**
 * Returns a unlinkDisplay failure error
 * @param {Error} error An error describing why the request failed
 */
function unlinkDisplayFailedAction(error) {
    return {
        type: pairing_1.actions.REMOTE_UNLINK_FAILED,
        payload: { error: error }
    };
}
function handleUnlinkDisplayFailure(reason, dispatch) {
    dispatch(unlinkDisplayFailedAction(reason));
    return Promise.reject(assign_1.default(reason, { type: pairing_1.actions.REMOTE_UNLINK_FAILED }));
}
function handleUnlinkDisplayResponse(response, tabletUUID, dispatch) {
    // Note: unlinkDisplayResponse can throw an error
    try {
        dispatch(unlinkDisplayResponseAction(response, tabletUUID));
        return Promise.resolve(assign_1.default(response, { type: pairing_1.actions.REMOTE_UNLINK_SUCCESS }));
    }
    catch (reason) {
        return handleUnlinkDisplayFailure(reason, dispatch);
    }
}
/**
 * Trigger the unlinking process from the remote (tablet)
 * The display receives REMOTE_UNLINK_BEGIN and calls unlinkDisplay() (above)
 */
function unlinkRemote(dispatch) {
    return dispatch(remoting_1.default.send(pairing_1.actions.REMOTE_UNLINK_BEGIN));
}
/**
 * Gets the current Device Info
 * This is useful if an action is missed due to connectivity
 */
function getDeviceInfo() {
    return function (dispatch, getState) {
        var state = getState();
        var uuid = safe_access_1.default(state, 'app.remoting.pairing.uuid') || '';
        return dispatch(nucleus_1.proxyActions.proxyApiCall(pairing_1.deviceInfoService.name, pairing_1.deviceInfoService.actions.get, HTTP_GET, {
            deviceUUID: uuid
        }))
            .then(function (response) { return dispatch(getDeviceInfoResponse(response)); })
            .catch(function (reason) { return dispatch(getDeviceInfoFailed(reason)); });
    };
}
/**
 * Returns a getDeviceInfo response action
 * @param response An HTTP response object
 */
function getDeviceInfoResponse(response) {
    var _a = JSON.parse(response), body = _a.body, statusCode = _a.statusCode;
    var responseBody = (body && JSON.parse(body)) || {};
    if (statusCode && statusCode >= 400) {
        return getDeviceInfoFailed(responseBody);
    }
    var _b = safe_access_1.default(responseBody, 'deviceInfo') || {}, linkedDevices = _b.linkedDevices, displayCipher = _b.roomPairingCipher, displayPlatform = _b.controllerType, licenseStatus = _b.licenseStatus;
    // note userUUID (the uuid of the user that is associated with the deviceUuid (the display itself)) is also available here but we don't currently have a use for it
    var pairedUuid = safe_access_1.default(linkedDevices.find(function (device) { return device.type === pairing_1.linkedDeviceTypes.tablet || device.type === pairing_1.linkedDeviceTypes.gemsTablet; }), 'linkedDeviceUUID') || null;
    var presenters = linkedDevices.reduce(function (result, device) {
        if (device.type === pairing_1.linkedDeviceTypes.presenter || device.type == pairing_1.linkedDeviceTypes.gemsPresenter) {
            result.push(device.linkedDeviceUUID);
        }
        return result;
    }, []);
    return {
        type: pairing_1.actions.GET_DISPLAY_DEVICE_INFO_SUCCESS,
        payload: {
            displayCipher: displayCipher,
            displayPlatform: displayPlatform,
            pairedUuid: pairedUuid,
            presenters: presenters,
            licenseStatus: licenseStatus
        }
    };
}
/**
 * Returns a getDeviceInfo failure error
 * @param {Error} error An error describing why the request failed
 */
function getDeviceInfoFailed(error) {
    return {
        type: pairing_1.actions.GET_DISPLAY_DEVICE_INFO_FAILED,
        payload: { error: error }
    };
}
/**
 * Gets the login cipher (for remotes) or the jwt (for presenters)
 * The response is determined by the type of linkingCode provided (determined during generateLinkingCode())
 * * IMPORTANT: we cannot use the device pairing service here because the presenter is not yet logged in and no WAMP connection exists
 * @param {string} linkingCode A string generated by generateLinkingCode (above)
 * @param deviceType
 */
function getAccountDetails(linkingCode, deviceType) {
    var _this = this;
    if (deviceType === void 0) { deviceType = pairing_1.linkedDeviceTypes.tablet; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var requestBody, isTabletLinking, url, response, successActionType, e_1, failedActionType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        pairingCode: linkingCode
                    };
                    isTabletLinking = deviceType == pairing_1.linkedDeviceTypes.tablet || deviceType == pairing_1.linkedDeviceTypes.gemsTablet;
                    url = safe_access_1.default(getState(), 'nucleus.cluster.url') === PROD_CLUSTER_URL
                        ? pairing_1.devicePairingService.url.prod
                        : pairing_1.devicePairingService.url.stage;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, {
                            body: JSON.stringify(requestBody),
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            method: HTTP_POST
                        })];
                case 2: return [4 /*yield*/, (_a.sent()).json()];
                case 3:
                    response = _a.sent();
                    if (safe_access_1.default(response, 'result') !== 'success')
                        throw safe_access_1.default(response, 'message');
                    successActionType = isTabletLinking ? pairing_1.actions.GET_CIPHER_SUCCESS : pairing_1.actions.GET_PRESENTER_TOKEN_SUCCESS;
                    dispatch({ type: successActionType, payload: response });
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    failedActionType = isTabletLinking ? pairing_1.actions.GET_CIPHER_FAILED : pairing_1.actions.GET_PRESENTER_TOKEN_FAILED;
                    dispatch({ type: failedActionType, payload: e_1 });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
}
/**
 * Gets the device login credentials (JWT) from a cipher
 * @param {string} cipher A string given by getAccountDetails (above)
 * @param {string} uuid A string given by getAccountDetails (above)
 * @param {boolean} isDisplay
 */
function getDeviceLogin(cipher, uuid, isDisplay) {
    var _this = this;
    if (isDisplay === void 0) { isDisplay = false; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var requestBody, url, response, error, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        client_id: isDisplay ? CLIENT_ID_DASH_DISPLAY : CLIENT_ID_DASH_REMOTE,
                        grant_type: pairing_1.loginService.grantType,
                        token: cipher,
                        uuid: uuid
                    };
                    url = safe_access_1.default(getState(), 'nucleus.cluster.url') === PROD_CLUSTER_URL ? pairing_1.loginService.url.prod : pairing_1.loginService.url.stage;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, {
                            body: JSON.stringify(requestBody),
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            method: HTTP_POST
                        })];
                case 2: return [4 /*yield*/, (_a.sent()).json()];
                case 3:
                    response = _a.sent();
                    error = safe_access_1.default(response, 'ERROR');
                    // TODO: check this error handler and figure out what to do if this fails (try again?)
                    // ...we need a way for the end user to recover if something goes wrong
                    // TODO: this fails occasionally due to a race case between when the license is consumed (display device is created)
                    // and when login services knows that the device exists.
                    // - We need a follow up ticket for CSS to send us a message when login services knows about the newly created display device
                    // - ...or, the response returning the cipher needs to wait until login services knows about the newly created display device
                    if (error)
                        throw error;
                    dispatch({ type: pairing_1.actions.GET_DEVICE_LOGIN_SUCCESS, payload: response });
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    dispatch({ type: pairing_1.actions.GET_DEVICE_LOGIN_FAILED, payload: { error: error_1 } });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
}
function subscribeToLinking() {
    return nucleus_1.proxyActions.subscribe(pairing_1.topics.pairingTopic);
}
function unsubscribeFromLinking() {
    return nucleus_1.proxyActions.unsubscribe(pairing_1.topics.pairingTopic);
}
// To be used when the request to update the PIN has been approved
// and we want the new pin to propagate down to our paired device
var setLocalPin = function (pin) { return ({ type: pairing_1.actions.SET_LOCAL_PIN, payload: pin }); };
// To be used to request to change the PIN of the device
// Note: this action will NOT actually change the PIN locally
var requestPinChange = function (pin) { return ({ type: pairing_1.actions.REQUEST_PIN_CHANGE, payload: pin }); };
exports.default = {
    createDevice: createDevice,
    generateLinkingCode: generateLinkingCode,
    getAccountDetails: getAccountDetails,
    getDeviceInfo: getDeviceInfo,
    getDeviceLogin: getDeviceLogin,
    requestPinChange: requestPinChange,
    setLocalPin: setLocalPin,
    subscribeToLinking: subscribeToLinking,
    unlinkDisplay: unlinkDisplay,
    unlinkConnect: unlinkConnect,
    unlinkRemote: unlinkRemote,
    unsubscribeFromLinking: unsubscribeFromLinking,
    updateDeviceSetting: updateDeviceSetting,
    unlinkDisplayAsAdmin: unlinkDisplayAsAdmin,
    resetPairingState: resetPairingState
};
